module.exports = __webpack_public_path__ + "img/public/SiteIcons/sayIcon.png?c9d672a7";